import React from 'react'

function Footer() {
  return (
    <div className='py-5'>
        <div className='h-[1px] w-full bg-gray-500'></div>
        <div className='flex w-full justify-between'>
            <h1 className='text-base sm:text-xs'>Designed and Developed by Pranay Kamineny</h1>
            <h1 className='text-base sm:text-xs'>pranay.kamineny@gmail.com | 2024</h1>
        </div>
        
    </div>
    

  )
}

export default Footer;